import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, TextField, MenuItem, FormHelperText, DialogContentText, Grid, Box, Typography, Container, Button, Alert, AlertTitle } from '@mui/material';
import Notify from "../../../../Notify";
import { getData, postData } from "../../../../../services/library";
import { logEventos } from "../../../../../services/services";
import { UrlApi } from "../../../../../services/apirest";

export default function ModalAddlistaprecio(props) {
    const [empresaCli, setEmpresaCli] = useState([]);
    const [datoslista, setDatoslista] = useState({
        id_empresa: props.datos?.id_empresa ? props.datos.id_empresa : empresaCli && empresaCli[0]?.id_empresa,
        id_sucursal: null,
        id_segmento: null,
        precio_litro_con_iva: "",
        precio_litro_sin_iva: "",
        precio_kilo_con_iva: "",
        precio_kilo_sin_iva: "",
        vigencia: "",
        id_producto: "",
        usuario: localStorage.getItem('user'),
        fin_vigencia: null
    });
    const [disabledGuardar, setDisabledGuardar] = useState(false);

    const [notificacion, setNotificacion] = useState({
        open: false,
        mensaje: "",
        severity: "",
        color: "",
    });

    const today = new Date().toISOString().split("T")[0]; // Formato YYYY-MM-DD

    const getEmpresa = () => {
        getData(`/empresas/cliente/${props.datos.id}`, setEmpresaCli)
    };

    useEffect(() => {
        getEmpresa()
    }, []);

    const almacenar = (event) => {
        const { name, value } = event.target;
        let newValue = { ...datoslista, [name]: value };
        if (value === "") {
            setDatoslista({
                ...datoslista,
                precio_litro_sin_iva: "",
                precio_litro_con_iva: "",
                precio_kilo_sin_iva: "",
                precio_kilo_con_iva: "",
                [name]: "",  // por si el name es otro campo relacionado
            });
            return; // salimos de la función para no seguir con cálculos
        };

        // Validar número con coma opcional y hasta 2 decimales
        if (!/^\d*([,]\d{0,2})?$/.test(value)) {
            setDatoslista(newValue);
            return;
        };

        const valorNormalizado =  name !== "id_empresa" ? value.replace(',', '.') : value;
        const floatValue = parseFloat(valorNormalizado);

        if (isNaN(floatValue)) {
            setDatoslista(newValue);
            return;
        };

        const densidad = datoslista?.id_empresa === 1
            ? props.direccion[0]?.densidad_hipergas
            : props.direccion[0]?.densidad_autogas;

        // 🔄 Redondeo al múltiplo más cercano de 0.05
        const redondearA05 = (num) => Math.round(num * 20) / 20;

        // 💡 Cálculos según campo modificado
        if (name === "precio_litro_sin_iva") {
            const sinIva = floatValue;
            const conIva = sinIva * props.direccion[0]?.valor;
            const kiloConIva = conIva / densidad;
            const kiloSinIva = kiloConIva / props.direccion[0]?.valor;

            newValue.precio_litro_con_iva = conIva.toFixed(2).replace('.', ',');
            newValue.precio_kilo_con_iva = kiloConIva.toFixed(2).replace('.', ',');
            newValue.precio_kilo_sin_iva = kiloSinIva.toFixed(2).replace('.', ',');
        }

        if (name === "precio_kilo_sin_iva") {
            const sinIva = floatValue;
            const conIva = sinIva * props.direccion[0]?.valor;
            const litroConIva = conIva * densidad;
            const litroSinIva = litroConIva / props.direccion[0]?.valor;

            newValue.precio_kilo_con_iva = conIva.toFixed(2).replace('.', ',');
            newValue.precio_litro_con_iva = litroConIva.toFixed(2).replace('.', ',');
            newValue.precio_litro_sin_iva = litroSinIva.toFixed(2).replace('.', ',');
        };

        if (name === "precio_litro_con_iva") {
            const conIva = floatValue;
            const sinIva = conIva / props.direccion[0]?.valor;
            const kiloSinIva = sinIva / densidad;
            const kiloConIva = kiloSinIva * props.direccion[0]?.valor;

            newValue.precio_litro_sin_iva = sinIva.toFixed(2).replace('.', ',');
            newValue.precio_kilo_sin_iva = kiloSinIva.toFixed(2).replace('.', ',');
            newValue.precio_kilo_con_iva = kiloConIva.toFixed(2).replace('.', ',');
        };

        if (name === "precio_kilo_con_iva") {
            const conIva = floatValue;
            const sinIva = conIva / props.direccion[0]?.valor;
            const litroConIva = sinIva * densidad;
            const litroSinIva = litroConIva / props.direccion[0]?.valor;

            newValue.precio_kilo_sin_iva = sinIva.toFixed(2).replace('.', ',');
            newValue.precio_litro_con_iva = litroConIva.toFixed(2).replace('.', ',');
            newValue.precio_litro_sin_iva = litroSinIva.toFixed(2).replace('.', ',');
        };

        setDatoslista(newValue);
    };

    const style = {
        backgroundColor: "#ffffff",
        width: "100%",
    };

    const size = "small";

    const guardarPrecio = async (e) => {
        const getNumericValue = (value) => {
            if (!value || typeof value !== 'string') return 0;
            const normalized = value.replace(',', '.');
            const parsed = parseFloat(normalized);
            return isNaN(parsed) ? 0 : parsed;
        };

        // Registrar evento
        logEventos(
            "Guardar nuevo precio desde alta pedidos",
            "Lista de Precios",
            "Se guardó el nuevo precio",
            localStorage.getItem("user")
        );

        // Realizar PUT a la API de clientes
        try {
            // Deshabilitar el botón mientras se procesa la solicitud
            setDisabledGuardar(true);
            await fetch(UrlApi + `/clientes/${props.datos.id}`, {
                method: 'PUT',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    id_empresa: datoslista.id_empresa
                })
            });

            // Hacer POST a la lista de precios
            await postData(
                e,
                '/lista_precios',
                {
                    id_sucursal: props.datos.id_sucursal,
                    id_segmento: props.segSelected.id,
                    id_producto: props.direccion[0]?.id_producto,
                    id_empresa: datoslista.id_empresa,
                    precio_litro_con_iva: getNumericValue(datoslista.precio_litro_con_iva),
                    precio_litro_sin_iva: getNumericValue(datoslista.precio_litro_sin_iva),
                    precio_kilo_con_iva: getNumericValue(datoslista.precio_kilo_con_iva),
                    precio_kilo_sin_iva: getNumericValue(datoslista.precio_kilo_sin_iva),
                    vigencia: datoslista.vigencia,
                    usuario: localStorage.getItem("user"),
                    fin_vigencia: datoslista.fin_vigencia
                },
                setNotificacion
            );

        } catch (error) {
            console.error("Error guardando el precio:", error);
            // Aquí puedes manejar el error o notificar al usuario
        } finally {
            // Rehabilitar el botón después de que las llamadas hayan finalizado
            setDisabledGuardar(false);
            props.actualizar()
        }
    };

    useEffect(() => {
        if (datoslista.precio_litro_con_iva === "" || datoslista.precio_litro_sin_iva === "" || datoslista.precio_kilo_con_iva === "" || datoslista.precio_kilo_sin_iva === "" || datoslista.vigencia === "") {
            setDisabledGuardar(true);
        }

        else {
            setDisabledGuardar(false);
        }
    }, [datoslista.precio_litro_con_iva, datoslista.precio_litro_sin_iva, datoslista.precio_kilo_con_iva, datoslista.precio_kilo_sin_iva, datoslista.vigencia]);

 const handleKeyDown = (e) => {

    // Permitir números y la coma
    if (!(
      (e.key >= '0' && e.key <= '9') ||
      e.key === ',' ||
      e.key === 'Backspace' ||  // permitir borrar
      e.key === 'ArrowLeft' ||   // permitir mover cursor
      e.key === 'ArrowRight' ||
      e.key === 'Tab'             // permitir tabular
    )) {
      e.preventDefault();
    }
  }

    return (
        <Dialog maxWidth="lg" open={props.open}>
            <DialogContent>
                <Alert severity="warning">
                    <AlertTitle>Atención</AlertTitle>

                    No hay una lista de precios registrada para empresa: {empresaCli && empresaCli[0]?.empresa} Sucursal: {props.datos.sucursal} Segmento: {props.segSelected && props.segSelected.segmento} Producto: {props.direccion[0]?.nombre}`

                </Alert>
                <DialogContentText>
                    <Box p={2}>
                        <Typography variant="caption" display="block" gutterBottom>
                            A continuación, puede registrar una nueva
                        </Typography>
                    </Box>
                </DialogContentText>

                <form onSubmit={guardarPrecio} autoComplete="off">
                    <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        spacing={2}
                    >
                        <Grid item xs={2}>
                            <TextField
                                select
                                fullWidth
                                size="small"
                                style={{ backgroundColor: "#ffffff" }}
                                focused
                                color="primary"
                                required
                                name="id_empresa"
                                label="Seleccionar Empresa"
                                variant="outlined"
                                value={datoslista.id_empresa}
                                onChange={almacenar}
                            >
                                <MenuItem value={4}>Natural Gas</MenuItem>
                                <MenuItem value={1}>Hipergas</MenuItem>
                            </TextField>
                            <FormHelperText error={!empresaCli[0]}>
                                {(empresaCli[0]?.id_empresa === '' || empresaCli[0]?.id_empresa === null) || datoslista.id_empresa === null
                                    ? 'El cliente no tiene empresa, por favor seleccione una.'
                                    : null}
                            </FormHelperText>
                        </Grid>
                        <Grid item xs={2}>
                            <TextField
                                fullWidth
                                size={size}
                                style={style}
                                focused
                                color="primary"
                                required
                                name="precio_litro_sin_iva"
                                label="Precio litro sin IVA"
                                variant="outlined"
                                value={datoslista.precio_litro_sin_iva}
                                onChange={almacenar}
                                onKeyDown={(e) => { handleKeyDown (e)}}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField
                                fullWidth
                                size={size}
                                style={style}
                                focused
                                color="primary"
                                required
                                name="precio_litro_con_iva"
                                label="Precio litro con IVA"
                                variant="outlined"
                                value={datoslista.precio_litro_con_iva}
                                onChange={almacenar}
                                onKeyDown={(e) => { handleKeyDown (e)}}
                            />
                        </Grid>

                        <Grid item xs={2}>
                            <TextField
                                fullWidth
                                size={size}
                                style={style}
                                focused
                                color="primary"
                                required
                                name="precio_kilo_sin_iva"
                                label="Precio kilo sin IVA"
                                variant="outlined"
                                value={datoslista.precio_kilo_sin_iva}
                                onKeyDown={(e) => { handleKeyDown (e)}}
                                onChange={almacenar}
                            />
                        </Grid>

                        <Grid item xs={2}>
                            <TextField
                                fullWidth
                                size={size}
                                style={style}
                                focused
                                color="primary"
                                required
                                name="precio_kilo_con_iva"
                                label="Precio kilo con IVA"
                                variant="outlined"
                                value={datoslista.precio_kilo_con_iva}
                                onKeyDown={(e) => { handleKeyDown (e)}}
                                onChange={almacenar}
                            />
                        </Grid>

                        <Grid item xs={2}>
                            <TextField
                                fullWidth
                                size={size}
                                style={style}
                                focused
                                color="primary"
                                required
                                type="date"
                                name="vigencia"
                                label="Vigencia"
                                variant="outlined"
                                value={datoslista.vigencia}
                                onChange={almacenar}
                                InputProps={{
                                    inputProps: {
                                        min: today
                                    }
                                }}
                            />
                        </Grid>

                        <Grid item xs={2}>
                            <TextField
                                fullWidth
                                size={size}
                                style={style}
                                focused
                                color="primary"
                                // required
                                type="date"
                                name="fin_vigencia"
                                label=" Fin Vigencia"
                                variant="outlined"
                                value={datoslista.fin_vigencia}
                                onChange={almacenar}
                            // InputProps={{
                            //     inputProps: {
                            //         min: datoslista.vigencia
                            //     }
                            // }}
                            />
                        </Grid>


                    </Grid>
                    <Grid
                        container
                        justifyContent="space-between"
                        alignItems="flex-end"
                        mt={2}
                    >
                        <Button variant="contained" onClick={props.onClose} color="error">
                            Volver
                        </Button>

                        <Button
                            variant="contained"
                            type="submit"
                            color={"success"}
                            onClick={guardarPrecio}
                            disabled={disabledGuardar}
                        >
                            Guardar Precio
                        </Button>
                    </Grid>
                </form>
                {notificacion && notificacion.open ? (
                    <Notify
                        mensaje={notificacion.mensaje}
                        open={notificacion.open}
                        color={notificacion.color}
                        handleClose={props.onClose}
                        severity={notificacion.severity}
                    />
                ) : null}

            </DialogContent>
        </Dialog>
    )
}
